const ROOT = 'dashboard/activities-logs/'

export default {
	arrayList: `${ROOT}list`,
	arrayListDropdown: `${ROOT}dropdown`,
}
